(function () {
    'use strict';

    angular
        .module('franchisee-portal.directives')
        .directive('newsTemplate', NewsTemplate)

    /** @ngInject */
    function NewsTemplate($timeout, $window, FileService, HelperService, AuthenticationService, PATHS, ROUTES, LOCAL_STORAGE_ITEMS) {
        function NewsTemplateController() {
            const vm = this;

            vm.formatSize = FileService.formatSize;

            vm.getRegisterArea = registerArea => {
                let area = '';

                if (registerArea == 1)
                    area = 'Arquivo';
                else if (registerArea == 2)
                    area = 'Pasta';
                else if (registerArea == 3)
                    area = 'Comunicado';
                else if (registerArea == 4)
                    area = 'Evento';
                else if (registerArea == 5)
                    area = 'Mídia';
                else if (registerArea == 6)
                    area = 'Vídeo';

                return area;
            }

            vm.getRegisterImage = register => {
                if (register.RegisterArea == 5)
                    return HelperService.imageResizePath('news', register.Id, register.Image, 500, 250);
                else if (register.RegisterArea == 4)
                    return HelperService.imageResizePath('event', register.Id, register.Image, 500, 250);
            }

            vm.getAreaIcon = registerArea => {
                let icon = 'icomoon-';

                if (registerArea == 1)
                    icon = icon.concat('files');
                else if (registerArea == 2)
                    icon = icon.concat('folder');
                else if (registerArea == 3)
                    icon = icon.concat('communicates');
                else if (registerArea == 4)
                    icon = icon.concat('events');
                else if (registerArea == 5)
                    icon = icon.concat('playtv');
                else if (registerArea == 6)
                    icon = icon.concat('university');

                return icon;
            }

            vm.getFileIcon = file => {
                return HelperService.imageHandlerFileIcon(file.Extension.trim());
            }

            vm.getCategoryIcon = register => {
                if (register.RegisterArea == 5)
                    return HelperService.imageHandlerPath('news-category', register.Category.Id, register.Category.Icon);
            }

            vm.downloadFile = file => {
                let accessToken = localStorage.getItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN);
                let userData = AuthenticationService.getUserData();

                return FileService
                    .verifyDownload(file.Id)
                    .then(() => $window.location.href = `${ROUTES.API}/files/download/${userData.Id}/${file.Id}?accessToken=${accessToken}`, error => HelperService.errorCallback(error));
            }

            vm.showFileModal = file => {
                vm.selectedFile = file;

                $timeout(() => {
                    $('#modalDetailsFile').modal('show');
                });
            }

            vm.init = () => {
                if (vm.templateId == 1 && vm.registers.length) {
                    vm.featuredRegister = vm.registers[0];
                    vm.registers.splice(0, 1);
                }
            }
        }

        function link(scope, attrs, elem, ctrl) {
            ctrl.init();
        }

        return {
            bindToController: true,
            controller: NewsTemplateController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: (elem, attrs) => `${PATHS.PHYSICAL}/directives/news-template/news-template-${attrs.templateId}.html`,
            link: link,
            scope: {
                templateId: '@',
                registers: '='
            }
        }
    }
}());